import TextField from "@mui/material/TextField"
import Autocomplete from "@mui/material/Autocomplete"
import { PostAdminContext } from "./Posts"
import { useContext } from "react"

const PostLicenseNumberFilter = ({ maxWidth }) => {
	const postAdminContext = useContext(PostAdminContext)
	const handleLicenseNumberFilter = postAdminContext.handleLicenseNumberFilter
	const posts = postAdminContext.posts

	return (
		<Autocomplete
			disablePortal
			options={posts.map((post) => {
				//console.log(post.licenseNumber)

				return {
					/* label: formatLicenseNumber(post.licenseNumber), */
					label: post.licenseNumber,
					id: post.licenseNumber,
				}
			})}
			renderInput={(params) => <TextField {...params} label="מודעה" />}
			size="small"
			sx={{ width: "100%", pb: 2, pt: 1, maxWidth: maxWidth ?? "auto" }}
			onChange={(event, newValue) => {
				handleLicenseNumberFilter(newValue)
			}}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			renderOption={(props, option, { selected }) => (
				<li {...props} key={option.id}>
					<span>{option.label}</span>
				</li>
			)}
		/>
	)
}

export default PostLicenseNumberFilter
